import React from 'react';
import { colors } from 'design-system';
import { CustomColor } from 'design-system/dist/components/Inputs/hooks/useTextInputStyles';
import { Moon, Sun } from 'react-feather';
import { getLoginBackgroundImage } from './getLoginBackgroundImage';

/** It determines at what time light and dark theme shows */

export function getCurrentTimeTheme(date: Date): string {
  const hour = date.getHours();
  if (hour >= 6 && hour < 18) {
    return 'light';
  }
  return 'dark';
}

type ThemeValues = {
  backgroundImage: string;
  welcomeTextColor: string;
  logoIcon: string;
  morningNightMessage: string;
  customInputColors: CustomColor | undefined;
  sunMoonIcon: React.ReactNode;
  footerColor: string;
};

/** This sets up light and dark theme values */

export function getThemeValues(isMobile: boolean, date: Date): ThemeValues {
  let dayBackground = `${getLoginBackgroundImage(
    date,
    false,
  )}, linear-gradient(180deg, #DEF0FF, #FFFFFD ,#FFFFFE, #FFFFFF)`;
  let nightBackground = `${getLoginBackgroundImage(
    date,
    true,
  )}, linear-gradient(#0D2E68,#123E8A,#1E59C0)`;

  if (isMobile) {
    dayBackground = 'linear-gradient(#DEF0FF,#FFFFFF)';
    nightBackground = 'linear-gradient(#0D2E68,#154DAE)';
  }

  if (getCurrentTimeTheme(date) === 'light') {
    const hour = date.getHours();
    const morningMessage = hour < 12 ? 'Buenos días' : 'Buenas tardes';
    return {
      backgroundImage: dayBackground,
      welcomeTextColor: colors.madison,
      logoIcon: '../svg/assa_logo.svg',
      morningNightMessage: morningMessage,
      customInputColors: undefined,
      sunMoonIcon: (
        <Sun
          color={colors.lightning_yellow}
          size={20}
          style={{
            marginTop: 4,
            marginLeft: 8,
          }}
          fill={colors.lightning_yellow}
        />
      ),
      footerColor: colors.light_silver,
    };
  }

  return {
    backgroundImage: nightBackground,
    welcomeTextColor: colors.white,
    logoIcon: '../svg/white_assa_logo.svg',
    morningNightMessage: 'Buenas noches',
    customInputColors: {
      font: colors.white,
      border: colors.white,
      icon: colors.madison,
    },
    sunMoonIcon: (
      <Moon
        color={colors.white}
        size={20}
        style={{
          marginTop: 4,
          marginLeft: 8,
        }}
      />
    ),
    footerColor: colors.white,
  };
}
